import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useUrlParams, Dropdown } from 'components';
import { showApiError } from 'utils';
import { getActionFilters } from 'services';
import { actionStatusFilterOptions, ACTION_STATUS } from 'enums';
import { tableHeaderContainer } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var filterField = {
  flex: '1 1 180px',
  maxWidth: 240,
  minWidth: 140
};

var ActionsTableHeader = function ActionsTableHeader(_ref) {
  var getData = _ref.getData;

  var _useUrlParams = useUrlParams(),
      urlQueryParams = _useUrlParams.urlQueryParams;

  var _useState = useState({
    employees: [],
    credits: [],
    borrowers: []
  }),
      _useState2 = _slicedToArray(_useState, 2),
      filters = _useState2[0],
      setFilters = _useState2[1];

  var _useState3 = useState(urlQueryParams.status || ACTION_STATUS.active),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedStatus = _useState4[0],
      setSelectedStatus = _useState4[1];

  var employeeId = urlQueryParams.employeeId,
      creditId = urlQueryParams.creditId,
      borrowerId = urlQueryParams.borrowerId;
  var queryParams = useRef(_objectSpread(_objectSpread({}, urlQueryParams), {}, {
    status: urlQueryParams.status || ACTION_STATUS.active
  }));
  useEffect(function () {
    getData(queryParams.current);
    fetchFilters();
  }, []);

  var fetchFilters = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getActionFilte, _yield$getActionFilte2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getActionFilters();

            case 2:
              _yield$getActionFilte = _context.sent;
              _yield$getActionFilte2 = _slicedToArray(_yield$getActionFilte, 2);
              res = _yield$getActionFilte2[0];
              err = _yield$getActionFilte2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setFilters(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchFilters() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleEmployeeChange = function handleEmployeeChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      employeeId: value
    });
    getData(queryParams.current);
  };

  var handleCreditChange = function handleCreditChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      creditId: value
    });
    getData(queryParams.current);
  };

  var handleBorrowerChange = function handleBorrowerChange(value) {
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      borrowerId: value
    });
    getData(queryParams.current);
  };

  var handleStatusChange = function handleStatusChange(value) {
    setSelectedStatus(value);
    queryParams.current = _objectSpread(_objectSpread({}, queryParams.current), {}, {
      status: value
    });
    getData(queryParams.current);
  };

  return ___EmotionJSX("section", {
    css: tableHeaderContainer
  }, ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u0421\u043B\u0443\u0436\u0438\u0442\u0435\u043B",
    displayKey: "name",
    uniqueKey: "id",
    value: employeeId,
    options: filters.employees,
    onChange: handleEmployeeChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041A\u0440\u0435\u0434\u0438\u0442 \u2116",
    displayKey: "number",
    uniqueKey: "id",
    value: creditId,
    options: filters.credits,
    onChange: handleCreditChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u041A\u0440\u0435\u0434\u0438\u0442\u043E\u0438\u0441\u043A\u0430\u0442\u0435\u043B",
    displayKey: "full_name",
    uniqueKey: "id",
    value: borrowerId,
    options: filters.borrowers,
    onChange: handleBorrowerChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })), ___EmotionJSX("div", {
    style: filterField
  }, ___EmotionJSX(Dropdown, {
    small: true,
    placeholder: "\u0421\u0442\u0430\u0442\u0443\u0441",
    value: selectedStatus,
    options: actionStatusFilterOptions,
    onChange: handleStatusChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.value;
    }
  })));
};

ActionsTableHeader.propTypes = {
  getData: PropTypes.func
};
export default ActionsTableHeader;